export const GET_STUDENT_CLESSON_RESULT_REQUEST = 'STUDENT_CLESSON_RESULT.GET_STUDENT_CLESSON_RESULT_REQUEST';
export const GET_STUDENT_CLESSON_RESULT_SUCCESS = 'STUDENT_CLESSON_RESULT.GET_STUDENT_CLESSON_RESULT_SUCCESS';
export const GET_STUDENT_CLESSON_RESULT_ERROR = 'STUDENT_CLESSON_RESULT.GET_STUDENT_CLESSON_RESULT_ERROR';
export const CLEAR = 'STUDENT_CLESSON_RESULT.CLEAR';
